import { toast } from "react-toastify";
import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { notifiy } from "../../notification/Notification";
import { Dialog, DialogContent, DialogActions, TextField, Button,
} from "@mui/material";
import { useState } from "react";

export const handleApproval = async (selectedApproveIds) => {
  const userID = localStorage.getItem("id") || "";
  const jobIds = selectedApproveIds.join(", ");
  try {
    // Step 1: Fetch IR IDs where jobRegisterInspectionId matches
       const getIdsQuery = {
        query: `SELECT u.id as userinspectorId, ir.id, ir.inspectorId, ir.reportNo, u.userName as inspectorName FROM IR ir LEFT JOIN users u ON ir.inspectorId = u.id WHERE ir.jobRegisterInspectionId IN (${jobIds});`,
      };
    const res = await axiosWithToken.post(BASE_URL + `dynamic`, getIdsQuery);
     const irRecords = res.data;
    const irIds = res.data.map((row) => row.id);
    if (irRecords.length === 0) {
      toast.error("No matching IR records found.");
      return;
    }
    // Step 2: Update approvedBy using the retrieved IR IDs
    const updateQuery = {
      query: `UPDATE IR SET rejectedBy = Null, approvedBy = '${userID}' WHERE id IN (${irIds.join(", ")});`,
    };

    await axiosWithToken.post(BASE_URL + `dynamic`, updateQuery);

    // Step 3: Send notification to each inspectortype
    for (const record of irRecords) {
      if (record.userinspectorId) {
        const notification = {
          _from: userID,
          _to: record.userinspectorId,
          body: `Your Inspection Report ${record.reportNo} has been approved`,
          type: 1,
        };        
        notifiy(notification, () => {
          console.log(`Approval notification sent`);
        });
      }
    }
    toast.success("Approved Successfully!");
    setTimeout(() => {
      window.location.reload(false);
    }, 500);
  } catch (err) {
    console.error("Approval Error:", err);
  }
};


export const RejectionModal = ({ open, onClose, selectedIds, onSuccess }) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [loading, setLoading] = useState(false);
  const userID = localStorage.getItem("id") || "";

  const handleReject = async () => {
    if (!rejectionReason.trim()) {
      toast.error("Please provide a rejection reason.");
      return;
    }

    setLoading(true);
    const jobIds = selectedIds.join(", ");
    
    try {
      // Step 1: Fetch IR IDs and inspectortype details
      // const getIdsQuery = {
      //   query: `SELECT id FROM IR WHERE jobRegisterInspectionId IN (${jobIds});`,
      // };
       const getIdsQuery = {
        query: `SELECT u.id as userinspectorId, ir.id, ir.inspectorId, ir.reportNo, u.userName as inspectorName FROM IR ir LEFT JOIN users u ON ir.inspectorId = u.id WHERE ir.jobRegisterInspectionId IN (${jobIds});`,
      };
      const res = await axiosWithToken.post(BASE_URL + `dynamic`, getIdsQuery);
      const irRecords = res.data;

      if (irRecords.length === 0) {
        toast.error("No matching IR records found.");
        setLoading(false);
        return;
      }

      const irIds = irRecords.map((row) => row.id);
      // Step 2: Update rejectedBy and clear approvedBy
      const updateQuery = {
        query: `UPDATE IR SET requestApproval = 1, rejectedBy = '${userID}', approvedBy = NULL WHERE id IN (${irIds.join(", ")});`,
      };
      await axiosWithToken.post(BASE_URL + `dynamic`, updateQuery);
      // Step 3: Send notification to each inspectortype
      for (const record of irRecords) {
        if (record.userinspectorId) { 
          const notification = {
            _from: userID,
            _to: record.userinspectorId,
            body: `Your Inspection Report ${record.reportNo} has been rejected.:\nReason:\n${rejectionReason}`,
            type: 1,
          };          
          notifiy(notification, () => {
            console.log(`Rejection notification sent`);
          });
        }
      }

      toast.success("Rejected Successfully!");
      setLoading(false);
      setRejectionReason("");
      onClose();
      
      setTimeout(() => {
        if (onSuccess) onSuccess();
        else window.location.reload();
      }, 500);
    } catch (err) {
      console.error("Rejection Error:", err);
      toast.error("Failed to reject. Please try again.");
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setRejectionReason("");
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ overflow: "hidden" }}>
        <TextField
          label="Rejection Reason *"
          multiline
          rows={4}
          fullWidth
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
          variant="outlined"
          margin="normal"
          placeholder="Enter reason for rejection..."
          required
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleReject}
          disabled={loading || !rejectionReason.trim()}
          color="error"
          variant="contained"
        >
          {loading ? "Rejecting..." : "Reject"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};